import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store/store"; // Import your store
import "./index.css";
import App from "./App";
import Footer from "./components/Foorter";

// Get the root element
const rootElement = document.getElementById("root");

// Create a root and render your app
const root = ReactDOM.createRoot(rootElement);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
